import { render, staticRenderFns } from "./LearningRequestQuestion.vue?vue&type=template&id=28041ffa"
import script from "./LearningRequestQuestion.vue?vue&type=script&lang=js"
export * from "./LearningRequestQuestion.vue?vue&type=script&lang=js"
import style0 from "./LearningRequestQuestion.vue?vue&type=style&index=0&id=28041ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports